import React from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
export type logoBannerProps = {
    readonly svgArray: React.ElementType[];
};

const logoBox = css({
    width: "100%",
    height: "15rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    background: "#F4F5F7",
    clipPath: "polygon(0 0, 100% 0, 100% 87%, 0 100%)",
    zIndex: "-1",
    marginBlockStart: "-3px",
    [media.only.md]: {
        justifyContent: "end",
        width: "100%"
    },
    [media.only.sm]: {
        justifyContent: "end",
        width: "100%"
    },
    [media.below.sm]: {
        width: "100%",
        height: "11rem",
        justifyContent: "center",
        clipPath: "polygon(0 0, 100% 0, 100% 92%, 0 100%)"
    }
});

const logoContainer = css({
    width: "85%",
    height: "86px",
    display: "flex",
    justifyContent: "space-evenly",
    opacity: "0.7",
    div: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    [media.only.md]: {
        gap: "30px 56px",
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        justifyItems: "start",
        div: {
            maxWidth: "80px",
            minWidth: "50px",
            height: "40px",
            margin: "0",
            padding: "0"
        },
        svg: {
            width: "auto",
            height: "100%"
        },
        ["> .item-1"]: { order: 1 },
        ["> .item-2"]: { order: 2, maxWidth: "120px" },
        ["> .item-3"]: { order: 6, width: "40px" },
        ["> .item-4"]: { order: 3 },
        ["> .item-5"]: { order: 4, minWidth: "100px" },
        ["> .item-6"]: { order: 5 }
    },
    [media.only.sm]: {
        gap: "30px 56px",
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        justifyItems: "start",
        div: {
            maxWidth: "80px",
            minWidth: "50px",
            height: "40px",
            margin: "0",
            padding: "0"
        },
        svg: {
            width: "auto",
            height: "100%"
        },
        ["> .item-1"]: { order: 1 },
        ["> .item-2"]: { order: 2, maxWidth: "120px" },
        ["> .item-3"]: { order: 6, width: "40px" },
        ["> .item-4"]: { order: 3 },
        ["> .item-5"]: { order: 4, minWidth: "100px" },
        ["> .item-6"]: { order: 5 }
    },
    [media.below.sm]: {
        height: "3rem",
        gap: "10px 56px",
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        justifyItems: "center",
        div: {
            maxWidth: "80px",
            minWidth: "50px",
            height: "40px",
            margin: "0",
            padding: "0"
        },
        svg: {
            width: "auto",
            height: "100%"
        },
        ["> .item-1"]: { order: 1 },
        ["> .item-2"]: { order: 2, maxWidth: "120px" },
        ["> .item-3"]: { order: 6, width: "40px" },
        ["> .item-4"]: { order: 3 },
        ["> .item-5"]: { order: 4, minWidth: "100px" },
        ["> .item-6"]: { order: 5 }
    }
});

export const LogoBanner = ({ svgArray }: logoBannerProps) => {
    return (
        <div css={logoBox}>
            <div css={logoContainer}>
                {svgArray.map((Component: React.ElementType, index: number) => {
                    return (
                        <div key={index} className={`item-${index + 1}`}>
                            <Component />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
LogoBanner.displayName = "LogoBanner";
